import { TFunc } from '@Translations/types';

// Component names must satisfy ESRI's service naming rules (copied from
// app-am-data-management, see I360P-1369):
// https://doc.esri.com/en/arcgis-pro/latest/tool-reference/tool-errors-and-warnings/001001-010000/tool-errors-and-warnings-04251-04275-004264.html
// - only letters, numbers, and underscores (no spaces or other characters)
// - must start with a letter (not a number, period, or underscore)
// - must not start with the reserved prefix "esri__"
// - max 111 bytes (the character set above is ASCII-only, so chars == bytes)
export const ESRI_SERVICE_NAME_MAX_LENGTH = 111;
const ALLOWED_CHARS_REGEX = /^[a-zA-Z0-9_]*$/;
const STARTS_WITH_LETTER_REGEX = /^[a-zA-Z]/;
const ESRI_RESERVED_PREFIX_REGEX = /^esri__/i;

// Returns an error message if `value` violates ESRI's service naming rules,
// or undefined if it's valid (an empty value is treated as valid here -
// required-ness is a separate concern for callers to handle).
export const getEsriServiceNameError = (
	t: TFunc,
	value: string | undefined,
): string | undefined => {
	if (!value) return undefined;

	if (!ALLOWED_CHARS_REGEX.test(value)) {
		return t('No special characters or spaces are allowed.');
	}
	if (!STARTS_WITH_LETTER_REGEX.test(value)) {
		return t('Name must start with a letter');
	}
	if (ESRI_RESERVED_PREFIX_REGEX.test(value)) {
		return t('Name cannot start with the reserved prefix "esri__"');
	}
	if (value.length > ESRI_SERVICE_NAME_MAX_LENGTH) {
		return t('Cannot exceed {{max}} characters', {
			max: ESRI_SERVICE_NAME_MAX_LENGTH,
		});
	}
	return undefined;
};
